import { render } from "./VideoPlayerControlsVolume.vue?vue&type=template&id=0cf82b5a&scoped=true"
import script from "./VideoPlayerControlsVolume.vue?vue&type=script&lang=js"
export * from "./VideoPlayerControlsVolume.vue?vue&type=script&lang=js"

import "./VideoPlayerControlsVolume.vue?vue&type=style&index=0&id=0cf82b5a&scoped=true&lang=scss"

import exportComponent from "/Users/sxdube/Documents/code/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf82b5a"]])

export default __exports__